/* eslint-disable sonarjs/cognitive-complexity */
'use client';

import {
  ActionIcon,
  Avatar,
  Button,
  Center,
  CloseIcon,
  rem,
  SimpleGrid,
  Text,
  Title,
} from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import { useEffect } from 'react';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useDetectModalStore } from '@/stores';

export type ModalSendSmsToRecipientRejejectProps = ContextModalProps<{
  //
}>;

export default function SendSmsToRecipientRejeject({
  context,
  id,
}: ModalSendSmsToRecipientRejejectProps) {
  const setDetectModalId = useDetectModalStore.use.setDetectModalId();
  const clearDetectModalId = useDetectModalStore.use.clearDetectModalId();
  const isMobile = useIsMobile();

  useEffect(() => {
    setDetectModalId(id);
    return () => {
      clearDetectModalId();
    };
  }, [id, setDetectModalId, clearDetectModalId]);

  return (
    <>
      <Center
        styles={{
          root: {
            position: 'relative',
          },
        }}
      >
        <Avatar
          radius="md"
          variant="outline"
          size={rem(148)}
          flex="none"
          src={
            'https://appuat.ahamove.com/assets/images/sendsms-request-not-available.svg'
          }
          alt={'sms'}
          styles={{
            placeholder: {
              border: 'none',
            },
            image: {
              objectFit: 'contain',
            },
          }}
        ></Avatar>
        <ActionIcon
          size={44}
          variant="transparent"
          c="neutral"
          pos="absolute"
          top={0}
          left={isMobile ? 0 : 'calc(100% - 44px)'}
          onClick={() => context.closeAll()}
          style={{ outline: 'none !important' }}
        >
          <CloseIcon />
        </ActionIcon>
      </Center>
      <Title
        px={{ base: rem(0), sm: rem(8) }}
        pt={{ base: rem(16), sm: rem(24) }}
        ta="center"
        order={4}
        c="neutral.7"
      >
        Gửi SMS cho người nhận chỉ áp dụng cho 1 điểm giao hàng
      </Title>
      <Text
        fz={16}
        style={{ whiteSpace: 'pre-line' }}
        px={{ base: rem(0), sm: rem(8) }}
        py={{ base: rem(16), sm: rem(24) }}
      >
        Tìm hiểu thêm về dịch vụ tại đây để lần sau sử dụng cho các đơn hàng có
        1 điểm giao bạn nhé!{' '}
        <Text
          component="a"
          c={'primary.6'}
          href="https://ahamove.com/gioi-thieu-tinh-nang-gui-sms-theo-doi-hanh-trinh-cho-khach-hang"
          target="_blank"
        >
          Tìm hiểu thêm
        </Text>
      </Text>

      <SimpleGrid w="100%" cols={1} spacing="md">
        <Button
          radius="md"
          size="lg"
          fullWidth
          onClick={() => context.closeAll()}
        >
          Đóng
        </Button>
      </SimpleGrid>
    </>
  );
}
